// A transport being OPEN does not mean the account was authenticated.
function connectionRecoveryReason(socket, { hasCredentials = false, now = Date.now() } = {}) {
  if (!socket) return 'missing';
  if (socket.readyState === 2 || socket.readyState === 3) return 'closed';
  if (socket.readyState === 0) return now - (socket.createdAt ?? now) >= 10000 ? 'connect-timeout' : null;
  if (socket.readyState !== 1) return null;
  if (hasCredentials && socket.authenticated !== true)
    return now - (socket.openedAt ?? socket.createdAt ?? now) >= 10000 ? 'auth-timeout' : null;
  if (socket.authenticated === true && now - Math.max(socket.lastPresenceAck ?? socket.openedAt ?? now, socket.lastMessageAt ?? 0) >= 35000) return 'stale-presence';
  return null;
}
function reconnectDelay(attempt) { return Math.min(15000, 1000 * (2 ** Math.min(Math.max(0, attempt), 4))); }
module.exports = { connectionRecoveryReason, reconnectDelay };
